import React from "react";

const config = require("../../../config.json")
const client = config.APP_CLIENT;
const compagnyColorPrimary = config.APP_COMPAGNYCOLORPRIMARY;

const iconLogo = {
  marginRight: "3px",
};
const MailLink = {
  textDecoration: "none",
  color: compagnyColorPrimary,
  fontSize: "12px",
  margin: "0px 0px 0px",
  lineHeight: "12px",
};

export default function PostalAdress(adress) {
  return (
    <table style={{borderSpacing: 0}}>
      <tbody>
        <tr>
          <td>
            <img
              src={`https://files.myclientisrich.com/${client}/map.png`}
              style={iconLogo}
              alt="logo map"
              width="13"
              height="13"
            ></img>
          </td>
          <td>
            <span style={MailLink}>
              {adress.adress}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
